// extracted by mini-css-extract-plugin
export default {"wrapper":"One_wrapper__MSYS8"};